// extracted by mini-css-extract-plugin
module.exports = {"default":"item-list_default__GUUgR"};